<script lang="ts">
	import { currentMarket } from '../store';
	import { executionType, isTPSLActive } from './store';
	import TradeSettings from './TradeSettings.svelte';

	let showMenu = false;
	let showAdvancedOrdersMenu = false;

	const toggleSettings = () => {
		showMenu = !showMenu;
	};

	const toggleAdvancedOrdersMenu = () => {
		showAdvancedOrdersMenu = !showAdvancedOrdersMenu;
	};

	const closeMenu = () => {
		showMenu = false;
		showAdvancedOrdersMenu = false;
	};

	let advancedOrderDisplayText = 'Advanced Order';

	$: advancedOrderDisplayText =
		$executionType == 'Market' ? 'Advanced Order' : `${$executionType} Order`;
</script>

<div class="flex gap-4 justify-start items-center w-full mt-8 mb-6">
	<div
		class="px-4 py-2 text-fx-grey-400 text-xs rounded-lg squircle-lg cursor-pointer border-fx-grey-500"
		class:active-order-execution-type={$executionType == 'Market'}
		on:click={() => {
			isTPSLActive.set(false);
			executionType.set('Market');
		}}
		on:keydown={() => {
			isTPSLActive.set(false);
			executionType.set('Market');
		}}
		role="presentation"
	>
		Standard
	</div>

	{#if $currentMarket && $currentMarket.marketIdentifier}
		<div
			class="px-4 py-2 text-fx-grey-400 text-xs rounded-lg squircle-lg cursor-pointer border-fx-grey-500"
			class:active-order-execution-type={$executionType == 'Limit'}
			on:click={() => {
				isTPSLActive.set(false);
				executionType.set('Limit');
			}}
			on:keydown={() => {
				isTPSLActive.set(false);
				executionType.set('Limit');
			}}
			role="presentation"
		>
			Limit
		</div>
	{/if}

	{#if $currentMarket && $currentMarket.marketIdentifier}
		<div
			class="px-4 py-2 text-fx-grey-400 text-xs rounded-lg squircle-lg cursor-pointer border-fx-grey-500"
			class:active-order-execution-type={$executionType == 'Stop'}
			on:click={() => {
				isTPSLActive.set(false);
				executionType.set('Stop');
			}}
			on:keydown={() => {
				isTPSLActive.set(false);
				executionType.set('Stop');
			}}
			role="presentation"
		>
			Stop
		</div>
	{/if}

	<div class="grow" />
	<div class="cursor-pointer">
		<img
			loading="lazy"
			src={'trade-settings.svg'}
			alt="Trade Settings"
			on:click={toggleSettings}
			on:keydown={toggleSettings}
		/>
		<TradeSettings bind:showMenu />
	</div>
</div>

<style>
	.active-order-execution-type {
		@apply border  text-fx-grey-200 font-semibold ease-linear duration-100;
	}

	.flip-arrow {
		transform: rotate(180deg);
	}
</style>
